<app-form-input id="step5"
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="initial.delaiUrgence" 
 
[label]="step5.getdelaiurgence"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_delaiUrgence'">
</app-form-input>
